import { axiosInstance } from "./axiosInstance";

export const FAQProgramServices = {
  getAll: async (filter) => {
    return await axiosInstance.get('/api/feature/faq', { params: filter });
  },
  create: async (data) => {
    return await axiosInstance.post('/api/feature/faq/', data);
  },
  update: async (id, data) => {
    return await axiosInstance.post(`/api/feature/faq/update/${id}`, data);
  },
  delete: async (id) => {
    return await axiosInstance.delete(`/api/feature/faq/delete/${id}`);
  },
  attachDetach: async (id, data) => {
    return await axiosInstance.post(`/api/feature/faq/sync/${id}`, data);
  },
  order: async (id, data) => {
    return await axiosInstance.post(`/api/feature/faq/order/${id}`, data);
  }
}